import React, { useState } from 'react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import clsx from 'clsx';
import { PopoverClose } from '@radix-ui/react-popover';

const PropertySpacePopover = ({ defaultValue, onDataChange, ...props }) => {
  const [newPropertySpace, setNewPropertySpace] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isError, setIsError] = useState(false);
  const onSpaceChange = () => {
    if (
      newPropertySpace > 0 ||
      (newPropertySpace && newPropertySpace !== defaultValue)
    ) {
      onDataChange(newPropertySpace);
      setIsSubmitted(true);
    } else {
      setIsError(true);
    }
  };

  return (
    <Popover
      onOpenChange={(value) => {
        if (!value) {
          setIsSubmitted(false);
        }
      }}
    >
      <PopoverTrigger asChild className="h-auto">
        {props.children}
      </PopoverTrigger>
      <PopoverContent
        align="center"
        className="flex flex-col gap-2.5 text-[14px] max-w-[190px]"
      >
        <h2 className="font-bold">Boligens størrelse</h2>
        <div className="flex gap-2">
          <div className="relative">
            <Input
              className="shadow-none max-w-[73px] bg-[#f5f5f5]"
              type="text"
              name="propertySpace"
              label="Opprett mappe:"
              value={newPropertySpace || defaultValue}
              onChange={(event) => setNewPropertySpace(event.target.value)}
            />
            <span className="absolute right-1 top-1/2 -translate-y-1/2 pointer-events-none opacity-[50%]">
              m²
            </span>
          </div>
          <Button
            className={clsx([
              isError && 'border-red-400',
              'shadow-none px-2 py-3',
            ])}
            type="button"
            variant="outline"
            onClick={() => onSpaceChange()}
          >
            Oppdater
          </Button>
        </div>
        {isSubmitted ? (
          <>
            <p>Takk! Boligen din er oppdatert med ny størrelse.</p>
            <PopoverClose asChild>
              <Button className="shadow-none" type="button" variant="outline">
                Lukk
              </Button>
            </PopoverClose>
          </>
        ) : (
          <p className="opacity-[50%]">
            Endringen lagres bare her i Boligmappa, ikke hos tredjeparter som
            Kartverket.
          </p>
        )}
      </PopoverContent>
    </Popover>
  );
};

export default PropertySpacePopover;
